import { type PropsWithChildren } from 'react';
import styled from 'styled-components';

import { ContentMarginLine, GridRule } from '@/components/v2/GridLines';

import { LayoutSubgrid } from './LayoutGrid';

const V1Subgrid = styled(LayoutSubgrid)<{ $noTopPadding?: boolean }>`
  padding-top: ${({ $noTopPadding }) => ($noTopPadding ? 0 : '12.5rem')};
  overflow-x: clip;
  position: relative;
  isolation: isolate;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    padding-top: ${({ $noTopPadding }) => ($noTopPadding ? 0 : '9rem')};
  }

  & ~ & {
    padding-top: 0;
  }
`;

const ResponsiveGridRule = styled(GridRule)`
  @media (max-width: ${({ theme }) => theme.mediaQuery.MOBILE}) {
    display: none;
  }
`;

export function V1GridLines({ children }: PropsWithChildren) {
  return (
    <>
      <LayoutSubgrid aria-hidden="true" data-pile>
        <ResponsiveGridRule $column={4} />
        <GridRule $column={7} />
        <ResponsiveGridRule $column={10} />
      </LayoutSubgrid>
      <LayoutSubgrid data-pile>{children}</LayoutSubgrid>
    </>
  );
}

export function V1PageWrapper({
  children,
  noTopPadding
}: PropsWithChildren<{ noTopPadding?: boolean }>) {
  return (
    <>
      <ContentMarginLine data-v1-gridlines />
      <V1Subgrid $noTopPadding={noTopPadding} data-content-grid>
        {children}
      </V1Subgrid>
      <ContentMarginLine data-right data-v1-gridlines />
    </>
  );
}
